import Currency from '../../../common/Currency';
import DatePicker, {defaultDateFormat} from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'past_raises',
    _system: {
        name: 'All Past Raises',
        relatedTo: 'past_raises',
    },
    date: {
        label: 'Date',
        hideLabel: true,
        placeholder: 'Add Date',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date',
            relatedTo: 'past_raises'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date',
        rules: {
            title: 'Date'
        }
    },
    prev_rate: {
        prefix: '$',
        label: 'Previous Rate',
        hideLabel: true,
        placeholder: 'Add Previous Rate',
        system: {
            component: Currency,
            name: 'prev_rate',
            relatedTo: 'past_raises'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'prev_rate',
        rules: {
            title: 'Previous Rate field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        },
        grid: {
            className: 'col col-3'
        }
    },
    new_rate: {
        prefix: '$',
        label: 'New Rate',
        hideLabel: true,
        placeholder: 'Add New Rate',
        system: {
            component: Currency,
            name: 'new_rate',
            relatedTo: 'past_raises'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'new_rate',
        rules: {
            title: 'New Rate field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        },
        grid: {
            className: 'col col-3'
        }
    },
    raise_amount: {
        prefix: '$',
        label: 'Raise Amount',
        hideLabel: true,
        placeholder: 'Add Raise Amount',
        system: {
            component: Currency,
            name: 'raise_amount',
            relatedTo: 'past_raises'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'raise_amount',
        rules: {
            title: 'Raise Amount field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        },
        grid: {
            className: 'col col-3'
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/past_raises.js